import { render, staticRenderFns } from "./invoicePayExplain.vue?vue&type=template&id=1b4d41da&scoped=true&"
import script from "./invoicePayExplain.vue?vue&type=script&lang=js&"
export * from "./invoicePayExplain.vue?vue&type=script&lang=js&"
import style0 from "./invoicePayExplain.vue?vue&type=style&index=0&id=1b4d41da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4d41da",
  null
  
)

export default component.exports